export const ArchiveStatus = {
  SOME_ARCHIVED: 'SOME_ARCHIVED',
  ALL_ARCHIVED: 'ALL_ARCHIVED',
};
